const voices = {
  "af-ZA": {
    "Standard": [
      "F,Google.af-ZA-Standard-A"
    ]
  },
  "ar-AE": {
    "Premium": [
      "F,Polly.Hala-Neural *",
      "M,Polly.Zayd-Neural *"
    ]
  },
  "ar-XA": {
    "Standard": [
      "F,Google.ar-XA-Standard-A",
      "M,Google.ar-XA-Standard-B",
      "M,Google.ar-XA-Standard-C",
      "F,Google.ar-XA-Standard-D"
    ],
    "Premium": [
      "F,Google.ar-XA-Wavenet-A",
      "M,Google.ar-XA-Wavenet-B",
      "M,Google.ar-XA-Wavenet-C",
      "F,Google.ar-XA-Wavenet-D"
    ]
  },
  "bg-BG": {
    "Standard": [
      "F,Google.bg-BG-Standard-A"
    ]
  },
  "bn-IN": {
    "Standard": [
      "F,Google.bn-IN-Standard-C",
      "M,Google.bn-IN-Standard-D"
    ],
    "Premium": [
      "F,Google.bn-IN-Wavenet-C",
      "M,Google.bn-IN-Wavenet-D"
    ]
  },
  "cmn-CN": {
    "Standard": [
      "F,Polly.Zhiyu",
      "F,Google.cmn-CN-Standard-A",
      "M,Google.cmn-CN-Standard-B",
      "M,Google.cmn-CN-Standard-C",
      "F,Google.cmn-CN-Standard-D"
    ],
    "Premium": [
      "F,Google.cmn-CN-Wavenet-A",
      "M,Google.cmn-CN-Wavenet-B",
      "M,Google.cmn-CN-Wavenet-C",
      "F,Google.cmn-CN-Wavenet-D"
    ]
  },
  "cmn-TW": {
    "Standard": [
      "F,Google.cmn-TW-Standard-A",
      "M,Google.cmn-TW-Standard-B",
      "M,Google.cmn-TW-Standard-C"
    ],
    "Premium": [
      "F,Google.cmn-TW-Wavenet-A",
      "M,Google.cmn-TW-Wavenet-B",
      "M,Google.cmn-TW-Wavenet-C"
    ]
  },
  "cs-CZ": {
    "Standard": [
      "F,Google.cs-CZ-Standard-A"
    ],
    "Premium": [
      "F,Google.cs-CZ-Wavenet-A"
    ]
  },
  "cy-GB": {
    "Standard": [
      "F,Polly.Gwyneth"
    ]
  },
  "da-DK": {
    "Standard": [
      "M,Polly.Mads",
      "F,Polly.Naja",
      "F,Google.da-DK-Standard-A",
      "M,Google.da-DK-Standard-C",
      "F,Google.da-DK-Standard-D",
      "F,Google.da-DK-Standard-E"
    ],
    "Premium": [
      "F,Polly.Sofie-Neural",
      "F,Google.da-DK-Wavenet-A",
      "M,Google.da-DK-Wavenet-C",
      "F,Google.da-DK-Wavenet-D",
      "F,Google.da-DK-Wavenet-E"
    ]
  },
  "de-DE": {
    "Basic": [
      "M,Man",
      "F,Woman"
    ],
    "Standard": [
      "M,Polly.Hans",
      "F,Polly.Marlene",
      "F,Polly.Vicki",
      "F,Google.de-DE-Standard-A",
      "M,Google.de-DE-Standard-B",
      "F,Google.de-DE-Standard-C",
      "M,Google.de-DE-Standard-D",
      "M,Google.de-DE-Standard-E",
      "F,Google.de-DE-Standard-F"
    ],
    "Premium": [
      "F,Polly.Vicki-Neural",
      "M,Polly.Daniel-Neural",
      "F,Google.de-DE-Wavenet-A",
      "M,Google.de-DE-Wavenet-B",
      "F,Google.de-DE-Wavenet-C",
      "M,Google.de-DE-Wavenet-D",
      "M,Google.de-DE-Wavenet-E",
      "F,Google.de-DE-Wavenet-F",
      "F,Google.de-DE-Neural2-A",
      "M,Google.de-DE-Neural2-B",
      "F,Google.de-DE-Neural2-C",
      "M,Google.de-DE-Neural2-D",
      "F,Google.de-DE-Neural2-F"
    ]
  },
  "en-AU": {
    "Standard": [
      "F,Polly.Nicole",
      "M,Polly.Russell",
      "F,Google.en-AU-Standard-A",
      "M,Google.en-AU-Standard-B",
      "F,Google.en-AU-Standard-C",
      "M,Google.en-AU-Standard-D"
    ],
    "Premium": [
      "F,Polly.Olivia-Neural",
      "F,Google.en-AU-Wavenet-A",
      "M,Google.en-AU-Wavenet-B",
      "F,Google.en-AU-Wavenet-C",
      "M,Google.en-AU-Wavenet-D",
      "F,Google.en-AU-Neural2-A",
      "M,Google.en-AU-Neural2-B",
      "F,Google.en-AU-Neural2-C",
      "M,Google.en-AU-Neural2-D"
    ]
  },
  "en-GB": {
    "Basic": [
      "M,Man",
      "F,Woman"
    ],
    "Standard": [
      "F,Polly.Amy",
      "M,Polly.Brian",
      "F,Polly.Emma",
      "F,Google.en-GB-Standard-A",
      "M,Google.en-GB-Standard-B",
      "F,Google.en-GB-Standard-C",
      "M,Google.en-GB-Standard-D",
      "F,Google.en-GB-Standard-F"
    ],
    "Premium": [
      "F,Polly.Amy-Neural",
      "F,Polly.Emma-Neural",
      "M,Polly.Brian-Neural",
      "M,Polly.Arthur-Neural",
      "F,Google.en-GB-Wavenet-A",
      "M,Google.en-GB-Wavenet-B",
      "F,Google.en-GB-Wavenet-C",
      "M,Google.en-GB-Wavenet-D",
      "F,Google.en-GB-Wavenet-F",
      "F,Google.en-GB-Neural2-A",
      "M,Google.en-GB-Neural2-B",
      "F,Google.en-GB-Neural2-C",
      "M,Google.en-GB-Neural2-D",
      "F,Google.en-GB-Neural2-F"
    ]
  },
  "en-IE": {
    "Premium": [
      "F,Polly.Niamh-Neural"
    ]
  },
  "en-US": {
    "Basic": [
      "M,Man",
      "F,Woman"
    ],
    "Standard": [
      "F,Polly.Ivy",
      "F,Polly.Joanna",
      "M,Polly.Joey",
      "M,Polly.Justin",
      "F,Polly.Kendra",
      "F,Polly.Kimberly",
      "M,Polly.Matthew",
      "F,Polly.Salli",
      "M,Google.en-US-Standard-A",
      "M,Google.en-US-Standard-B",
      "F,Google.en-US-Standard-C",
      "M,Google.en-US-Standard-D",
      "F,Google.en-US-Standard-E",
      "F,Google.en-US-Standard-F",
      "F,Google.en-US-Standard-G",
      "F,Google.en-US-Standard-H",
      "M,Google.en-US-Standard-I",
      "M,Google.en-US-Standard-J"
    ],
    "Premium": [
      "F (child),Polly.Ivy-Neural",
      "F,Polly.Joanna-Neural*",
      "F,Polly.Kendra-Neural",
      "M (child),Polly.Kevin-Neural",
      "F,Polly.Kimberly-Neural",
      "F,Polly.Salli-Neural",
      "M,Polly.Joey-Neural",
      "M (child),Polly.Justin-Neural",
      "M,Polly.Matthew-Neural*",
      "F,Polly.Ruth-Neural",
      "M,Polly.Stephen-Neural",
      "M,Polly.Gregory-Neural",
      "F,Polly.Danielle-Neural",
      "M,Google.en-US-Wavenet-A",
      "M,Google.en-US-Wavenet-B",
      "F,Google.en-US-Wavenet-C",
      "M,Google.en-US-Wavenet-D",
      "F,Google.en-US-Wavenet-E",
      "F,Google.en-US-Wavenet-F",
      "F,Google.en-US-Wavenet-G",
      "F,Google.en-US-Wavenet-H",
      "M,Google.en-US-Wavenet-I",
      "M,Google.en-US-Wavenet-J",
      "M,Google.en-US-Neural2-A",
      "F,Google.en-US-Neural2-C",
      "M,Google.en-US-Neural2-D",
      "F,Google.en-US-Neural2-E",
      "F,Google.en-US-Neural2-F",
      "F,Google.en-US-Neural2-G",
      "F,Google.en-US-Neural2-H",
      "M,Google.en-US-Neural2-I",
      "M,Google.en-US-Neural2-J"
    ]
  },
  "en-ZA": {
    "Premium": [
      "F,Polly.Ayanda-Neural"
    ]
  },
  "el-GR": {
    "Standard": [
      "F,Google.el-GR-Standard-A"
    ],
    "Premium": [
      "F,Google.el-GR-Wavenet-A"
    ]
  },
  "es-MX": {
    "Basic": [
      "M,Man",
      "F,Woman"
    ],
    "Standard": [
      "F,Polly.Mia"
    ],
    "Premium": [
      "F,Polly.Mia-Neural",
      "M,Polly.Andres-Neural"
    ]
  },
  "es-ES": {
    "Basic": [
      "M,Man",
      "F,Woman"
    ],
    "Standard": [
      "F,Polly.Conchita",
      "M,Polly.Enrique",
      "F,Polly.Lucia",
      "M,Google.es-ES-Standard-B",
      "F,Google.es-ES-Standard-C",
      "F,Google.es-ES-Standard-D"
    ],
    "Premium": [
      "F,Polly.Lucia-Neural",
      "M,Polly.Sergio-Neural",
      "F,Google.es-ES-Wavenet-C",
      "F,Google.es-ES-Wavenet-D",
      "F,Google.es-ES-Neural2-A",
      "M,Google.es-ES-Neural2-B",
      "F,Google.es-ES-Neural2-C",
      "F,Google.es-ES-Neural2-D",
      "F,Google.es-ES-Neural2-E",
      "M,Google.es-ES-Neural2-F"
    ]
  },
  "fi-FI": {
    "Standard": [
      "F,Google.fi-FI-Standard-A"
    ],
    "Premium": [
      "F,Polly.Suvi-Neural",
      "F,Google.fi-FI-Wavenet-A"
    ]
  },
  "fil-PH": {
    "Standard": [
      "F,Google.fil-PH-Standard-A",
      "F,Google.fil-PH-Standard-B",
      "M,Google.fil-PH-Standard-C",
      "M,Google.fil-PH-Standard-D"
    ],
    "Premium": [
      "F,Google.fil-PH-Wavenet-A",
      "F,Google.fil-PH-Wavenet-B",
      "M,Google.fil-PH-Wavenet-C",
      "M,Google.fil-PH-Wavenet-D"
    ]
  },
  "fr-FR": {
    "Basic": [
      "M,Man",
      "F,Woman"
    ],
    "Standard": [
      "F,Polly.Céline/Polly.Celine",
      "F,Polly.Léa/Polly.Lea",
      "M,Polly.Mathieu",
      "F,Google.fr-FR-Standard-A",
      "M,Google.fr-FR-Standard-B",
      "F,Google.fr-FR-Standard-C",
      "M,Google.fr-FR-Standard-D",
      "F,Google.fr-FR-Standard-E"
    ],
    "Premium": [
      "F,Polly.Lea-Neural",
      "M,Polly.Remi-Neural",
      "F,Google.fr-FR-Wavenet-A",
      "M,Google.fr-FR-Wavenet-B",
      "F,Google.fr-FR-Wavenet-C",
      "M,Google.fr-FR-Wavenet-D",
      "F,Google.fr-FR-Wavenet-E",
      "F,Google.fr-FR-Neural2-A",
      "M,Google.fr-FR-Neural2-B",
      "F,Google.fr-FR-Neural2-C",
      "M,Google.fr-FR-Neural2-D",
      "F,Google.fr-FR-Neural2-E"
    ]
  },
  "gu-IN": {
    "Standard": [
      "F,Google.gu-IN-Standard-C",
      "M,Google.gu-IN-Standard-D"
    ],
    "Premium": [
      "F,Google.gu-IN-Wavenet-C",
      "M,Google.gu-IN-Wavenet-D"
    ]
  },
  "he-IL": {
    "Standard": [
      "F,Google.he-IL-Standard-A",
      "M,Google.he-IL-Standard-B",
      "F,Google.he-IL-Standard-C",
      "M,Google.he-IL-Standard-D"
    ],
    "Premium": [
      "F,Google.he-IL-Wavenet-A",
      "M,Google.he-IL-Wavenet-B",
      "F,Google.he-IL-Wavenet-C",
      "M,Google.he-IL-Wavenet-D"
    ]
  },
  "hi-IN": {
    "Standard": [
      "F,Polly.Aditi *",
      "M,Google.hi-IN-Standard-B",
      "M,Google.hi-IN-Standard-C",
      "F,Google.hi-IN-Standard-D"
    ],
    "Premium": [
      "F,Polly.Kajal-Neural *",
      "F,Google.hi-IN-Wavenet-A",
      "M,Google.hi-IN-Wavenet-B",
      "M,Google.hi-IN-Wavenet-C",
      "F,Google.hi-IN-Wavenet-D",
      "F,Google.hi-IN-Neural2-A",
      "M,Google.hi-IN-Neural2-B",
      "M,Google.hi-IN-Neural2-C",
      "F,Google.hi-IN-Neural2-D"
    ]
  },
  "hu-HU": {
    "Standard": [
      "F,Google.hu-HU-Standard-A"
    ],
    "Premium": [
      "F,Google.hu-HU-Wavenet-A"
    ]
  },
  "id-ID": {
    "Standard": [
      "F,Google.id-ID-Standard-A",
      "M,Google.id-ID-Standard-B",
      "M,Google.id-ID-Standard-C",
      "F,Google.id-ID-Standard-D"
    ],
    "Premium": [
      "F,Google.id-ID-Wavenet-A",
      "M,Google.id-ID-Wavenet-B",
      "M,Google.id-ID-Wavenet-C",
      "F,Google.id-ID-Wavenet-D"
    ]
  },
  "is-IS": {
    "Standard": [
      "F,Polly.Dóra/Polly.Dora",
      "M,Polly.Karl",
      "F,Google.is-IS-Standard-A"
    ]
  },
  "it-IT": {
    "Basic": [
      "M,Man",
      "F,Woman"
    ],
    "Standard": [
      "F,Polly.Bianca",
      "F,Polly.Carla",
      "M,Polly.Giorgio",
      "F,Google.it-IT-Standard-B",
      "M,Google.it-IT-Standard-C",
      "M,Google.it-IT-Standard-D"
    ],
    "Premium": [
      "F,Polly.Bianca-Neural",
      "M,Polly.Adriano-Neural",
      "F,Google.it-IT-Wavenet-B",
      "M,Google.it-IT-Wavenet-C",
      "M,Google.it-IT-Wavenet-D",
      "F,Google.it-IT-Neural2-A",
      "M,Google.it-IT-Neural2-C"
    ]
  },
  "ja-JP": {
    "Standard": [
      "F,Polly.Mizuki",
      "M,Polly.Takumi",
      "F,Google.ja-JP-Standard-B",
      "M,Google.ja-JP-Standard-C",
      "M,Google.ja-JP-Standard-D"
    ],
    "Premium": [
      "M,Polly.Takumi-Neural",
      "F,Polly.Kazuha-Neural",
      "F,Polly.Tomoko-Neural",
      "F,Google.ja-JP-Wavenet-B",
      "M,Google.ja-JP-Wavenet-C",
      "M,Google.ja-JP-Wavenet-D",
      "F,Google.ja-JP-Neural2-A",
      "M,Google.ja-JP-Neural2-B",
      "F,Google.ja-JP-Neural2-C",
      "F,Google.ja-JP-Neural2-D"
    ]
  },
  "ko-KR": {
    "Standard": [
      "F,Polly.Seoyeon",
      "F,Google.ko-KR-Standard-A",
      "F,Google.ko-KR-Standard-B",
      "M,Google.ko-KR-Standard-C",
      "M,Google.ko-KR-Standard-D"
    ],
    "Premium": [
      "F,Polly.Seoyeon-Neural",
      "F,Google.ko-KR-Wavenet-A",
      "F,Google.ko-KR-Wavenet-B",
      "M,Google.ko-KR-Wavenet-C",
      "M,Google.ko-KR-Wavenet-D",
      "F,Google.ko-KR-Neural2-A",
      "F,Google.ko-KR-Neural2-B",
      "M,Google.ko-KR-Neural2-C"
    ]
  },
  "lt-LT": {
    "Standard": [
      "M,Google.lt-LT-Standard-A"
    ]
  },
  "lv-LV": {
    "Standard": [
      "M,Google.lv-LV-Standard-A"
    ]
  },
  "ml-IN": {
    "Premium": [
      "F,Google.ml-IN-Wavenet-C",
      "M,Google.ml-IN-Wavenet-D"
    ]
  },
  "mr-IN": {
    "Standard": [
      "F,Google.mr-IN-Standard-A",
      "M,Google.mr-IN-Standard-B",
      "F,Google.mr-IN-Standard-C"
    ],
    "Premium": [
      "F,Google.mr-IN-Wavenet-A",
      "M,Google.mr-IN-Wavenet-B",
      "F,Google.mr-IN-Wavenet-C"
    ]
  },
  "ms-MY": {
    "Standard": [
      "F,Google.ms-MY-Standard-A",
      "M,Google.ms-MY-Standard-B",
      "F,Google.ms-MY-Standard-C",
      "M,Google.ms-MY-Standard-D"
    ],
    "Premium": [
      "F,Google.ms-MY-Wavenet-A",
      "M,Google.ms-MY-Wavenet-B",
      "F,Google.ms-MY-Wavenet-C",
      "M,Google.ms-MY-Wavenet-D"
    ]
  },
  "nb-NO": {
    "Standard": [
      "F,Polly.Liv",
      "F,Google.nb-NO-Standard-A",
      "M,Google.nb-NO-Standard-B",
      "F,Google.nb-NO-Standard-C",
      "M,Google.nb-NO-Standard-D",
      "F,Google.nb-NO-Standard-E"
    ],
    "Premium": [
      "F,Polly.Ida-Neural",
      "F,Google.nb-NO-Wavenet-A",
      "M,Google.nb-NO-Wavenet-B",
      "F,Google.nb-NO-Wavenet-C",
      "M,Google.nb-NO-Wavenet-D",
      "F,Google.nb-NO-Wavenet-E"
    ]
  },
  "nl-BE": {
    "Standard": [
      "F,Google.nl-BE-Standard-A",
      "M,Google.nl-BE-Standard-B"
    ],
    "Premium": [
      "F,Polly.Lisa-Neural",
      "F,Google.nl-BE-Wavenet-A",
      "M,Google.nl-BE-Wavenet-B"
    ]
  },
  "nl-NL": {
    "Standard": [
      "F,Polly.Lotte",
      "M,Polly.Ruben",
      "F,Google.nl-NL-Standard-A",
      "M,Google.nl-NL-Standard-B",
      "M,Google.nl-NL-Standard-C",
      "F,Google.nl-NL-Standard-D",
      "F,Google.nl-NL-Standard-E"
    ],
    "Premium": [
      "F,Polly.Laura-Neural",
      "F,Google.nl-NL-Wavenet-A",
      "M,Google.nl-NL-Wavenet-B",
      "M,Google.nl-NL-Wavenet-C",
      "F,Google.nl-NL-Wavenet-D",
      "F,Google.nl-NL-Wavenet-E"
    ]
  },
  "pa-IN": {
    "Standard": [
      "F,Google.pa-IN-Standard-A",
      "M,Google.pa-IN-Standard-B",
      "F,Google.pa-IN-Standard-C",
      "M,Google.pa-IN-Standard-D"
    ],
    "Premium": [
      "F,Google.pa-IN-Wavenet-A",
      "M,Google.pa-IN-Wavenet-B",
      "F,Google.pa-IN-Wavenet-C",
      "M,Google.pa-IN-Wavenet-D"
    ]
  },
  "pl-PL": {
    "Standard": [
      "M,Polly.Jacek",
      "M,Polly.Jan",
      "F,Polly.Ewa",
      "F,Polly.Maja"
    ],
    "Premium": [
      "F,Polly.Ola-Neural",
      "F,Google.pl-PL-Standard-A",
      "M,Google.pl-PL-Standard-B",
      "M,Google.pl-PL-Standard-C",
      "F,Google.pl-PL-Standard-D",
      "F,Google.pl-PL-Standard-E",
      "F,Google.pl-PL-Wavenet-A",
      "M,Google.pl-PL-Wavenet-B",
      "M,Google.pl-PL-Wavenet-C",
      "F,Google.pl-PL-Wavenet-D",
      "F,Google.pl-PL-Wavenet-E"
    ]
  },
  "pt-BR": {
    "Standard": [
      "F,Polly.Camila",
      "M,Polly.Ricardo",
      "F,Polly.Vitória/Polly.Vitoria",
      "M,Google.pt-BR-Standard-B",
      "F,Google.pt-BR-Standard-C"
    ],
    "Premium": [
      "F,Polly.Camila-Neural",
      "F,Polly.Vitoria-Neural",
      "M,Polly.Thiago-Neural",
      "F,Google.pt-BR-Wavenet-C",
      "F,Google.pt-BR-Neural2-A",
      "M,Google.pt-BR-Neural2-B",
      "F,Google.pt-BR-Neural2-C"
    ]
  },
  "pt-PT": {
    "Standard": [
      "F,Polly.Inês/Polly.Ines",
      "M,Polly.Cristiano",
      "F,Google.pt-PT-Standard-A",
      "M,Google.pt-PT-Standard-B",
      "M,Google.pt-PT-Standard-C",
      "F,Google.pt-PT-Standard-D"
    ],
    "Premium": [
      "F,Polly.Ines-Neural",
      "F,Google.pt-PT-Wavenet-A",
      "M,Google.pt-PT-Wavenet-B",
      "M,Google.pt-PT-Wavenet-C",
      "F,Google.pt-PT-Wavenet-D"
    ]
  },
  "ro-RO": {
    "Standard": [
      "F,Polly.Carmen",
      "M,Polly.Daniel",
      "M,Google.ro-RO-Standard-B",
      "F,Google.ro-RO-Standard-C"
    ],
    "Premium": [
      "F,Polly.Carmen-Neural",
      "M,Polly.Daniel-Neural",
      "F,Google.ro-RO-Wavenet-A",
      "M,Google.ro-RO-Wavenet-B",
      "F,Google.ro-RO-Neural2-A"
    ]
  },
  "ru-RU": {
    "Standard": [
      "F,Polly.Tatyana",
      "M,Polly.Dmitry",
      "M,Google.ru-RU-Standard-A",
      "F,Google.ru-RU-Standard-B"
    ],
    "Premium": [
      "M,Polly.Dmitry-Neural",
      "F,Polly.Tatyana-Neural",
      "M,Google.ru-RU-Wavenet-A",
      "M,Google.ru-RU-Wavenet-B"
    ]
  },
  "sv-SE": {
    "Standard": [
      "F,Polly.Astrid",
      "F,Google.sv-SE-Standard-A",
      "F,Google.sv-SE-Standard-B",
      "F,Google.sv-SE-Standard-C",
      "M,Google.sv-SE-Standard-D",
      "M,Google.sv-SE-Standard-E"
    ],
    "Premium": [
      "F,Polly.Elin-Neural",
      "F,Google.sv-SE-Wavenet-A",
      "F,Google.sv-SE-Wavenet-B",
      "F,Google.sv-SE-Wavenet-D",
      "M,Google.sv-SE-Wavenet-C",
      "M,Google.sv-SE-Wavenet-E"
    ]
  },
  "sk-SK": {
    "Standard": [
      "F,Google.sk-SK-Standard-A"
    ],
    "Premium": [
      "F,Google.sk-SK-Wavenet-A"
    ]
  },
  "sr-RS": {
    "Standard": [
      "F,Google.sr-RS-Standard-A"
    ]
  },
  "ta-IN": {
    "Standard": [
      "F,Google.ta-IN-Standard-C",
      "M,Google.ta-IN-Standard-D"
    ],
    "Premium": [
      "F,Google.ta-IN-Wavenet-C",
      "M,Google.ta-IN-Wavenet-D"
    ]
  },
  "th-TH": {
    "Standard": [
      "F,Google.th-TH-Standard-A"
    ]
  },
  "tr-TR": {
    "Standard": [
      "F,Polly.Filiz",
      "F,Google.tr-TR-Standard-A",
      "M,Google.tr-TR-Standard-B",
      "F,Google.tr-TR-Standard-C",
      "F,Google.tr-TR-Standard-D",
      "M,Google.tr-TR-Standard-E"
    ],
    "Premium": [
      "F,Google.tr-TR-Wavenet-A",
      "M,Google.tr-TR-Wavenet-B",
      "F,Google.tr-TR-Wavenet-C",
      "F,Google.tr-TR-Wavenet-D",
      "M,Google.tr-TR-Wavenet-E"
    ]
  },
  "uk-UA": {
    "Standard": [
      "F,Google.uk-UA-Standard-A"
    ],
    "Premium": [
      "F,Google.uk-UA-Wavenet-A"
    ]
  },
  "vi-VN": {
    "Standard": [
      "F,Google.vi-VN-Standard-A",
      "M,Google.vi-VN-Standard-B",
      "F,Google.vi-VN-Standard-C",
      "M,Google.vi-VN-Standard-D"
    ],
    "Premium": [
      "F,Google.vi-VN-Wavenet-A",
      "M,Google.vi-VN-Wavenet-B",
      "F,Google.vi-VN-Wavenet-C",
      "M,Google.vi-VN-Wavenet-D"
    ]
  },
  "yue-CN": {
    "Premium": [
      "F,Polly.Hiujin-Neural"
    ]
  },
  "yue-HK": {
    "Standard": [
      "F,Google.yue-HK-Standard-A",
      "M,Google.yue-HK-Standard-B",
      "F,Google.yue-HK-Standard-C",
      "M,Google.yue-HK-Standard-D"
    ]
  }
};

export function getVoicesByLanguage(languageCode) {
  return voices[languageCode] ? voices[languageCode] : [];
}

export function getVoices() {
  return voices;
}
